import axios from 'axios';

export default async function getDeletedCompanies({
  accessToken,
  page = 0,
  pageSize = 10,
  searchQuery = '',
  setTokenLikeExpired,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_COMPANIES_API_URL}/get-deleted?page=${page}&pageSize=${pageSize}&query=${searchQuery}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();
    
    return null;
  }
}
